import { toast } from '@systemeio/ui'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useSaveEmail = () => {
  const { fetcher } = useFetch({
    method: RequestMethodsEnum.post,
    badRequestHandler: error => {
      if (error.errors.fields && error.errors.fields.email)
        toast.error(error.errors.fields.email.join('\n'))
    },
  })
  const saveEmail = (email: string) => fetcher(`/api/dashboard/profile/change-email`, { email })
  return { saveEmail }
}
